//

import React, { useEffect } from 'react'

import { AppKitWrapper } from '@react/components/AppKitWrapper'
import UnconnectedApp from '@react/components/UnconnectedApp'
import { chainActions } from '@react/redux/chainSlice'
import { useOtChainState, useOtDispatch, useOtSelector } from '@react/redux/store'
import { RoleEnum } from '@shared/Enums'
import { logOT } from '@shared/loggingShared'
import { AuthProvider, useAuth } from 'react-oidc-context'

import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { LicenseInfo } from '@mui/x-license-pro'
import { ErrorBoundary } from '@react/components/ErrorBoundary'
import LytIssuerRouting from '@react/lyt/issuer/LytIssuerRouting'
import { BrowserRouter } from 'react-router-dom'
import Box from '@mui/material/Box'
import { TopAppBar } from '@react/topbar/TopAppBar'
LicenseInfo.setLicenseKey(
  '4aa820c74354bf0194df6f7dfa013a7fTz0xMTE4ODYsRT0xNzc3MDc1MTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'
)
export function LytIssuerOrProtocolManagerApp(): React.ReactElement {
  const {
    userConnection: { roleEnum },
    stageConfiguration: { domain, cognitoConfig },
  } = useOtChainState()
  const { clientId: cognitoClientId, userPoolId: cognitoUserPoolId } = cognitoConfig ?? {}
  const theme = useTheme()
  useEffect(() => {
    if (roleEnum === RoleEnum.ISSUER) {
      document.title = 'Lyt Issuer'
    } else if (roleEnum === RoleEnum.PROTOCOL_MANAGER) {
      document.title = 'Lyt Protocol Manager'
    } else if (roleEnum === RoleEnum.ISSUER_VAULT_WALLET) {
      document.title = 'Lyt Issuer Vault Wallet'
    } else if (roleEnum === RoleEnum.LENDER) {
      document.title = 'Lyt Lender'
    } else if (roleEnum === RoleEnum.BORROWER) {
      document.title = 'Lyt Borrower'
    }
  }, [roleEnum])

  let content

  // if (roleEnum === RoleEnum.PROTOCOL_MANAGER) {
  //   content = (
  //     <div
  //       className="App"
  //       style={{
  //         height: '100%',
  //         minHeight: '100vh',
  //         backgroundColor: theme.palette.background.canvas,
  //         overflow: 'scroll',
  //       }}
  //     >
  //       <title>LytPool Protocol Manager </title>

  //       <BrowserRouter>
  //         <ErrorBoundary>
  //           <LytProtocolManagerRouting />
  //         </ErrorBoundary>
  //       </BrowserRouter>
  //     </div>
  //   )
  // } else

  if (
    roleEnum === RoleEnum.ISSUER ||
    roleEnum === RoleEnum.BORROWER ||
    roleEnum === RoleEnum.PROTOCOL_MANAGER ||
    roleEnum === RoleEnum.ISSUER_VAULT_WALLET
  ) {
    content = (
      <div
        className="App"
        style={{
          height: '100%',
          minHeight: '100vh',
          backgroundColor: theme.palette.background.canvas,
          overflow: 'scroll',
        }}
      >
        <BrowserRouter>
          <ErrorBoundary>
            <LytIssuerRouting />
          </ErrorBoundary>
        </BrowserRouter>
      </div>
    )
  } else {
    content = (
      <BrowserRouter>
        <ErrorBoundary>
          <Box
            data-testid="LytIssuerRouting"
            sx={{
              height: '100vh',
              width: '100%',
              backgroundColor: theme.palette.background.canvas,
              overflow: 'scroll',
            }}
          >
            <TopAppBar></TopAppBar>
            <Typography variant="h1">No access</Typography>
          </Box>
        </ErrorBoundary>
      </BrowserRouter>
    )
  }

  const cognitoAuthConfig =
    cognitoClientId && cognitoUserPoolId && domain
      ? {
          authority: `https://cognito-idp.us-east-1.amazonaws.com/${cognitoUserPoolId}`,
          client_id: cognitoClientId,
          redirect_uri: `https://${domain.replace('app', 'admin')}`,
          response_type: 'code',
          scope: 'email openid',
          post_logout_redirect_uri: `https://${domain.replace('app', 'admin')}/logout.html`,
        }
      : undefined

  if (cognitoAuthConfig) {
    return (
      <AuthProvider {...cognitoAuthConfig}>
        <OdicLoginWrapper>
          <AppKitWrapper>
            <div style={{ flex: 1, overflow: 'auto' }}>{content}</div>
          </AppKitWrapper>
        </OdicLoginWrapper>
      </AuthProvider>
    )
  }
  return content
}

const OdicLoginWrapper: React.FC<{ children: React.ReactNode }> = ({ children }): React.ReactElement => {
  const auth = useAuth()
  const dispatch = useOtDispatch()
  const { cognitoUser } = useOtSelector((state) => state.chainState)

  useEffect(() => {
    if (auth.isAuthenticated) {
      logOT.info(' OdicLoginWrapper auth isAuthenticated')
      if (!cognitoUser && auth.user) {
        dispatch(chainActions.odicConnect(auth.user))
      }
    } else if (auth.isLoading) {
      logOT.info(' OdicLoginWrapper auth isLoading')
    } else if (auth.error) {
      logOT.info('OdicLoginWrapper  auth error', auth.error)
    } else {
      logOT.info('OdicLoginWrapper  auth signinRedirect')
      auth
        .signinRedirect()
        .then((user) => {
          logOT.info('OdicLoginWrapper  auth Redirect done', user)
        })
        .catch((error) => {
          logOT.error('OdicLoginWrapper OdicLoginWrapper  auth Redirect error', error)
        })
    }
  }, [auth.isAuthenticated, auth.isLoading, auth.error, auth.user, cognitoUser])

  if (auth.isLoading) {
    return <div>Loading...</div>
  }

  if (auth.error) {
    if (location.search.includes('code=')) {
      location.href = '/'
      return <div>Redirecting...</div>
    }
    return <div>Login error... {auth.error.message}</div>
  }

  if (auth.isAuthenticated) {
    return <>{children} </>
  }
  return <UnconnectedApp />
}
